
import { defineComponent, ref } from "vue";
import SkinProfileRow from "@/components/skin-profile/SkinProfileRow.vue";
import SkinProfileForm from "@/components/skin-profile/SkinProfileForm.vue";
import FloatingButton from "@/components/FloatingButton.vue";

import useSkinProfiles from "@/composition/skin-profile/skin-profile";
import useUpload from "@/composition/skin-profile/upload";
import {
  SkinProfileToAdd,
  SkinProfileTextFields
} from "@/controller/skin-profile";
import { FirebaseImage } from "@/controller/uploader";

export default defineComponent({
  name: "SkinProfile",

  components: {
    SkinProfileRow,
    SkinProfileForm,
    FloatingButton
  },

  setup() {
    const {
      skinProfiles,
      deleteSkinProfile,
      addSkinProfile
    } = useSkinProfiles();

    const { uploadSkinProfileImage } = useUpload();

    const shouldShowAddForm = ref(false);
    const showAddForm = () => (shouldShowAddForm.value = true);
    const closeAddForm = () => (shouldShowAddForm.value = false);

    async function onSubmitSkinProfileForm(
      skinProfileTextFields: SkinProfileTextFields,
      image: File
    ) {
      const uploadedImage: FirebaseImage = await uploadSkinProfileImage(image);

      const skinProfileToAdd: SkinProfileToAdd = {
        ...skinProfileTextFields,
        ...uploadedImage
      };

      await addSkinProfile(skinProfileToAdd);
      closeAddForm();
    }

    return {
      skinProfiles,
      deleteSkinProfile,
      onSubmitSkinProfileForm,
      shouldShowAddForm,
      showAddForm,
      closeAddForm
    };
  }
});
